import { SalesRoutingModule } from './sales-routing.module';
import { NgModule } from '@angular/core';
import { SalesComponent } from './sales.component';

@NgModule({
  declarations: [SalesComponent],
  imports: [
    SalesRoutingModule,
  ],
  exports: [SalesComponent]
})
export class SalesModule { }
